import React from "react";
import { Reveal } from "./Reveal";
import { SOCIALS } from "../data";
import { ArrowUpRight } from "lucide-react";

const SC_SRC =
  "https://w.soundcloud.com/player/?url=" +
  encodeURIComponent("https://soundcloud.com/tao_lumin") +
  "&color=%23003399&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true";

export const Music = () => {
  return (
    <section
      id="music"
      data-testid="music-section"
      className="relative py-24 md:py-40 bg-[#050505] overflow-hidden"
    >
      <div className="absolute right-[-10%] top-1/2 -translate-y-1/2 w-[560px] h-[560px] rounded-full bg-[#003399]/15 blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-4">
            <Reveal>
              <p className="text-[#003399] font-bold text-xs uppercase tracking-[0.3em] mb-6">
                Listen
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl md:text-6xl uppercase text-[#F2F2F2] leading-none">
                The
                <br />
                Sound
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-[#F2F2F2]/65 font-light leading-relaxed">
                Mixes, edits and productions straight from Nassau — spanning
                chilled lounge, deep funk and high-energy house. Press play and
                take the journey.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                data-testid="soundcloud-follow"
                href={SOCIALS.soundcloud}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-[#003399] text-[#F2F2F2] text-xs uppercase tracking-[0.2em] hover:shadow-[0_0_28px_rgba(0,51,153,0.8)] transition-shadow duration-300"
              >
                Follow on SoundCloud <ArrowUpRight size={16} />
              </a>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="md:col-span-8 w-full">
            <div className="border border-white/10 bg-black p-2 md:p-3">
              <iframe
                title="Tao Lumin on SoundCloud"
                data-testid="soundcloud-player"
                width="100%"
                height="420"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src={SC_SRC}
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Music;
